import { Anchor, Card } from '@zenid/web';
import { genericError } from '../../../../styled-system/recipes';

export function NotFound() {
  const { contentsLayout, contentsInnerLayout, iconLayout, icon, title, messageLayout, message, actionsLayout } =
    genericError();
  return (
    <Card className={contentsLayout}>
      <div className={contentsInnerLayout}>
        <div className={iconLayout}>
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/seagull_telescope.png`}
            className={icon}
            alt="NotFoundページのアイコン"
          />
        </div>
        <div className={messageLayout}>
          <h1 className={title}>ページが見つかりませんでした</h1>
          <p className={message}>
            ご指定のページは削除・変更されたか、現在ご利用いただけない可能性があります。
            <br />
            お手数ですが、「ZEN ID」トップページより再度お探しください。
          </p>
        </div>
        <div className={actionsLayout}>
          <Anchor variant="button" href="/home" color="primary" size="l" width={200}>
            ZEN IDに戻る
          </Anchor>
        </div>
      </div>
    </Card>
  );
}
